// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"694":"component---src-core-share-share-block-template-tsx","989":"component---src-core-pages-page-template-tsx"}[chunkId] || chunkId) + "-" + {"530":"c514905238fc91b2b83f","694":"d6c3f719923200e8dc3c","989":"c6c9b0ae76f1e40e7a39"}[chunkId] + ".js";
};